import { createAction } from "@reduxjs/toolkit";
import { LANGUAGE } from "../../locales/languages";
import { typeCurrentUser, typeNotificationItem } from "./systemReducer";

export const authLoaderAC = createAction(
  "AUTH_LOADER",
  (authLoader: boolean) => ({ payload: authLoader }),
);

export const authAC = createAction("AUTH", (login: string) => ({
  payload: {
    login: login,
  },
}));

export const refreshTokensSagaAC = createAction(
  "REFRESH_TOKENS_SAGA",
  (refreshToken: string) => ({
    payload: {
      refreshToken: refreshToken,
    },
  }),
);

export const authSagaAC = createAction(
  "AUTH_SAGA",
  (email: string, password: string, rememberChecked: boolean) => ({
    payload: {
      email: email,
      password: password,
      rememberChecked: rememberChecked,
    },
  }),
);

export const dashboardLoaderAC = createAction(
  "DASHBOARD_LOADER",
  (dashboardLoader: boolean) => ({ payload: dashboardLoader }),
);

export const authErrorAC = createAction("AUTH_ERROR", (authError: boolean) => ({
  payload: authError,
}));

export const logoutAC = createAction("LOGOUT");

export const logoutSagaAC = createAction("LOGOUT_SAGA");

export const forgotPasswordSagaAC = createAction(
  "FORGOT_PASSWORD_SAGA",
  (email: string) => ({
    payload: {
      email: email,
    },
  }),
);

export const languageAC = createAction(
  "CHANGE_LANGUAGE",
  (language: LANGUAGE) => ({ payload: language }),
);

export const addNotificationAC = createAction(
  "ADD_NOTIFICATION",
  (notificationObject: typeNotificationItem) => ({
    payload: notificationObject,
  }),
);

export const deleteNotificationAC = createAction(
  "DELETE_NOTIFICATION",
  (notificationId: string) => ({ payload: notificationId }),
);

export const setCurrentUserInfoSagaAC = createAction(
  "SET_CURRENT_USER_INFO_SAGA",
  (token: string) => ({
    payload: {
      token: token,
    },
  }),
);

export const setCurrentUserInfoAC = createAction(
  "SET_CURRENT_USER_INFO",
  (user: typeCurrentUser) => ({
    payload: {
      user: user,
    },
  }),
);

export const resetReducers = createAction(
  "RESET_REDUCERS",
  (current: string) => ({ payload: current }),
);
